import { useQuery } from "@tanstack/react-query";
import type { InvitationSort } from "@unbox/api";
import { client } from "@/api/client";
import { handleError } from "@/api/error";
import { type Pagination, toQuery } from "@/api/pagination";

export const useAdminInvites = (
  pagination: Pagination,
  sort: {
    column: InvitationSort;
    direction: "asc" | "desc";
  },
  {
    text,
    merchantId,
    workspaceId,
    status,
  }: { text?: string; merchantId?: string; workspaceId?: string; status?: "pending" | "accepted" | "revoked" },
) => {
  return useQuery({
    queryKey: [
      "admin",
      "invitation",
      pagination.limit,
      pagination.offset,
      sort.column,
      sort.direction,
      text,
      merchantId,
      workspaceId,
      status,
    ],
    queryFn: async () => {
      const res = await client.admin.invitation.$get({
        query: { ...toQuery(pagination), ...sort, text, merchantId, workspaceId, status },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
